import {
    CREATE_PROGRESS_REPORT,
    DELETE_PROGRESS_REPORT,
    EDIT_PROGRESS_REPORT,
    GET_PROGRESS_REPORTS,
    GET_PROGRESS_REPORTS_BY_ID,
} from './progressReport.types';

/** Progress Reports */

export const getProgressReports = (clientId, params, load) => {
    return {
        type: GET_PROGRESS_REPORTS,
        payload: { clientId, params, load },
    };
};
export const getProgressReportById = (id) => {
    return {
        type: GET_PROGRESS_REPORTS_BY_ID,
        payload: { id },
    };
};

export const createProgressReport = (clientId, body) => {
    return {
        type: CREATE_PROGRESS_REPORT,
        payload: { clientId, body },
    };
};

export const editProgressReport = (id, body) => {
    return {
        type: EDIT_PROGRESS_REPORT,
        payload: { id, body },
    };
};

export const deleteProgressReport = (id) => {
    return {
        type: DELETE_PROGRESS_REPORT,
        payload: { id },
    };
};

/** End */
